<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛ID" )
                    el-input.inputWidth(v-model='dataForm.matchId' clearable placeholder="请输入比赛ID")
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛名称" )
                    el-input.inputWidth(v-model='dataForm.matchName' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="主办方" )
                    el-select.inputWidth(v-model="dataForm.userGroupId",placeholder="请选择" filterable clearable )
                        el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛类型" )
                    el-select.inputWidth(v-model='dataForm.ctType' clearable )
                        el-option(label="常规赛" value="1")
                        el-option(label="月度赛" value="2")
                        el-option(label="季度赛" value="3")
                        el-option(label="年度总决赛" value="4")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="签位"  )
                    el-input.inputWidth(v-model='dataForm.applySize' clearable placeholder="请输入签位数" )
                      template(slot="suffix") 签位
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛项目")
                    el-select.inputWidth(v-model='dataForm.projectType' @change="changeItem" clearable )
                        el-option(label="单打" value="1")
                        el-option(label="双打" value="2")
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛级别")
                    el-select.inputWidth(v-model='dataForm.level' :disabled="levelDisabled" :placeholder="placeholderLevel" clearable )
                        el-option(v-for="item in levelOptions" :label="item.label" :value="item.value")
              el-col(:md='6' :sm="12")
                el-form-item(label="状态" )
                    el-select.matchStatus.inputWidth(v-model='dataForm.matchStatus' clearable  )
                        el-option(label="未审核" value="1")
                        el-option(label="已发布" value="2")
                        el-option(label="报名中" value="6")
                        el-option(label="报满可替" value="9")
                        el-option(label="已报满" value="10")
                        el-option(label="报名结束" value="7")
                        el-option(label="已开赛" value="8")
                        el-option(label="已取消" value="3")
                        el-option(label="已结束" value="4")
                        el-option(label="已拒绝" value="5")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="比赛时间")
                    el-date-picker.inputWidth( style='width:210px;'  v-model='dataForm.matchStartTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")

        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='10' :sm="5")
                el-button(@click='addOrUpdateHandle()' v-if="isAuth('ct:teenagers:save')"  type='primary') 新建比赛
            el-col( :md='14' :sm="14" style='float:right;')
                div(style='float:right;display:flex')
                  el-button(@click='downloadContestants',type='primary',icon='el-icon-download') 批量导出参赛名单
                  el-button(@click='queryList()',type='primary',icon='el-icon-search') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(type="selection" width="50" align='center')
            el-table-column(prop='matchId',header-align='center',align='center',label='比赛ID' width="160")
            el-table-column(prop='matchName',header-align='center',align='center',label='比赛名称' width="150")
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='ctType',header-align='center',align='center',label='比赛类型' width="90" )
                template(slot-scope='scope')
                    font(v-if='scope.row.ctType === 1') 常规赛
                    font(v-if='scope.row.ctType === 2') 月度赛
                    font(v-if='scope.row.ctType === 3') 季度赛
                    font(v-if='scope.row.ctType === 4') 年度总决赛
            el-table-column(prop='applySize',header-align='center',align='center',label='签位' width="60")
                template(slot-scope="scope")
                    span() {{scope.row.joinCount}}/{{scope.row.applySize}}
            el-table-column(prop='level',header-align='center',align='center',label='比赛级别' width="80")
            el-table-column(prop='matchStartTime',header-align='center',align='center',label='比赛时间' width='160')
            el-table-column(prop='refereeName',header-align='center',align='center',label='裁判' :show-overflow-tooltip='true')
            el-table-column(prop='matchStatus',header-align='center',align='center',label='状态' width="100")
                template(slot-scope="scope")
                    font(v-if='scope.row.matchStatus === 1' )
                      span.danger()
                      span() &nbsp; 未审核
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()>new Date().getTime()')
                      span.success()
                      span() &nbsp; 已发布
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount<scope.row.applySize')
                      span.warning()
                      span() &nbsp; 报名中
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==1')
                      span.warning()
                      span() &nbsp; 报满可替
                    font(v-if='scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==0')
                      span.warning()
                      span() &nbsp; 已报满
                    font(v-if='scope.row.matchStatus === 2 && new Date().getTime()>new Date(scope.row.matchSignEndTime).getTime() &&  new Date().getTime()<new Date(scope.row.matchStartTime).getTime()')
                      span.warning()
                      span() &nbsp; 报名结束
                    font(v-if='scope.row.matchStatus === 2 &&  new Date().getTime()>new Date(scope.row.matchStartTime).getTime()')
                      span.warning()
                      span() &nbsp; 已开赛
                    font(v-if='scope.row.matchStatus === 3')
                      span.warning()
                      span() &nbsp; 已取消
                    font(v-if='scope.row.matchStatus === 4')
                      span.warning()
                      span() &nbsp; 已结束
                    font(v-if='scope.row.matchStatus === 5')
                      span.warning()
                      span() &nbsp; 已拒绝
            el-table-column(prop='recommend',header-align='center',align='center',label='首页推荐' width="100")
                template(slot-scope='scope')
                    font(v-if='scope.row.recommend == 0') 未推荐
                    font(v-if='scope.row.recommend == 1') 已推荐
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id)" v-if="isAuth('ct:teenagers:info')" ) 查看详情
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,1)" v-if="isAuth('ct:teenagers:update') && (scope.row.matchStatus === 1 || scope.row.matchStatus === 5)"  type="text" ) 修改比赛
                                el-menu-item(index="1-2-1" @click="addOrUpdateHandle(scope.row.id,'reviewedEdit')" v-if="isAuth('ct:teenagers:update') && !([1, 3, 4, 5].includes(scope.row.matchStatus))" type="text" ) 修改比赛
                                el-menu-item(index="1-10" @click='releaseClick(9,scope.row)'  v-if="isAuth('ct:teenagers:manager') && scope.row.matchStatus !== 1 && scope.row.matchStatus !== 5" type='primary') 场地管理
                                el-menu-item(index="1-3" @click='releaseClick(1,scope.row)' v-if="isAuth('ct:teenagers:apply') && scope.row.matchStatus === 1" type='primary') 审核发布
                                el-menu-item(index="1-4" @click='releaseClick(2,scope.row)' v-if="isAuth('ct:teenagers:meber') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4)" type='primary') 参赛人员设置
                                el-menu-item(index="1-5" @click='releaseClick(3,scope.row)' v-if="isAuth('ct:teenagers:referee') && scope.row.matchStatus === 2" type='primary') 裁判设置
                                el-menu-item(index="1-6" @click='releaseClick(4,scope.row)' v-if="isAuth('ct:teenagers:score') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4) " type='primary') 成绩管理
                                el-menu-item(index="1-12" @click='releaseClick(10,scope.row)' v-if="isAuth('ct:teenagers:iframe') && (scope.row.matchStatus === 2 || scope.row.matchStatus === 4) && scope.row.thirdMatchId" type='primary') 战表管理
                                el-menu-item(index="1-7" @click='releaseClick(6,scope.row)' v-if="isAuth('ct:teenagers:out') && scope.row.matchStatus === 2" type='primary') 取消比赛
                                el-menu-item(index="1-8" @click='releaseClick(7,scope.row)' v-if="isAuth('ct:teenagers:over') && scope.row.matchStatus === 2" type='primary') 结束比赛
                                el-menu-item(index="1-9" @click='releaseClick(5,scope.row)' v-if="isAuth('ct:teenagers:copy')" type='primary') 复制并新建
                                el-menu-item(index="1-10" @click='recommend(scope.row.id,1)' type='primary'  v-if="scope.row.matchStatus === 2 && scope.row.recommend == 0" ) 推荐
                                el-menu-item(index="1-11" @click='recommend(scope.row.id,0)' type='primary'  v-if="scope.row.matchStatus === 2 && scope.row.recommend == 1" ) 取消推荐
                                //- el-menu-item(index="1-10" @click='releaseClick(8,scope.row)' v-if="isAuth('') && scope.row.matchStatus === 2 ") 调整赛制

        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //查看和审核
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='getDataList')
        //参数人员管理-单打
        elEnrollInfo(v-if='elEnrollInfoVisible',ref="elEnrollInfo",@refreshDataList='getDataList')
        elEnrollInfoOld(v-if='elEnrollInfoOldVisible',ref="elEnrollInfoOld",@refreshDataList='getDataList')
        //参数人员管理--双打
        elEnrollInfoDouble(v-if='elEnrollInfoDoubleVisible',ref="elEnrollInfoDouble",@refreshDataList='getDataList')
        elEnrollInfoDoubleOld(v-if='elEnrollInfoDoubleOldVisible',ref="elEnrollInfoDoubleOld",@refreshDataList='getDataList')
        //安排裁判
        updateReferee(v-if='updateRefereeVisible',ref="updateReferee",@refreshDataList='getDataList')
        //成绩管理-单打
        gradeInfo(v-if='gradeInfoVisible' ref="gradeInfo" @refreshDataList='getDataList')
        gradeInfoOld(v-if='gradeInfoOldVisible' ref="gradeInfoOld" @refreshDataList='getDataList')
        //成绩管理-双打
        gradeInfoDouble(v-if='gradeInfoDoubleVisible' ref="gradeInfoDouble" @refreshDataList='getDataList')
        gradeInfoDoubleOld(v-if='gradeInfoDoubleOldVisible' ref="gradeInfoDoubleOld" @refreshDataList='getDataList')
        // 调整赛制
        adjustGameSys(v-if='adjustGameSysVisible' ref="adjustGame" @refreshDataList='getDataList')
        // 场地管理
        siteDeploy(v-if='siteDeployVisible' ref="siteDeploy")
        // 战表管理
        matchIframe(ref="matchIframe")
</template>

<script>
import table from './table1.js'
import AddOrUpdate from './add-or-update'
import QueryView from './query-view'
import ElEnrollInfo from './el-enroll-info'
import ElEnrollInfoOld from './el-enroll-infoOld'
import ElEnrollInfoDouble from './el-enroll-info-double'
import ElEnrollInfoDoubleOld from './el-enroll-info-doubleOld'
import UpdateReferee from './update-referee'
import GradeInfo from './grade-info'
import GradeInfoOld from './grade-infoOld'
import GradeInfoDouble from './grade-info-double'
import GradeInfoDoubleOld from './grade-info-doubleOld'
import AdjustGameSys from './adjust-game-sys'
import siteDeploy from '../level/site-deploy.vue'
import matchIframe from '../iframe/index.vue'

export default {
  name: 'ct-competition-level',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      loading: null,
      gradeInfoVisible: false,
      gradeInfoOldVisible: false,
      gradeInfoDoubleVisible: false,
      gradeInfoDoubleOldVisible: false,
      updateRefereeVisible: false,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      elEnrollInfoOldVisible: false,
      elEnrollInfoDoubleVisible: false,
      elEnrollInfoDoubleOldVisible: false,
      siteDeployVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      // restaurants: [],
      dataForm: {
        matchId: null,
        matchName: null,
        userGroupId: null,
        level: null,
        ctType: null,
        applySize: null,
        projectType: null,
        matchStatus: null,
        matchStartTime: []
      },
      levelOptions: [],
      sysOrgList: [],
      levelDisabled: true,
      placeholderLevel: '必须先选择比赛项目',
      levelOptionsOne: [
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
        { value: '3.5', label: '3.5' },
        { value: '4.0', label: '4.0' },
        { value: '4.5', label: '4.5' },
        { value: '5.0', label: '5.0' }
      ],
      levelOptionsTwo: [
        { value: '5.0', label: '5.0' },
        { value: '6.0', label: '6.0' },
        { value: '7.0', label: '7.0' },
        { value: '8.0', label: '8.0' },
        { value: '9.0', label: '9.0' },
        { value: '10.0', label: '10.0' }
      ],
      adjustGameSysVisible: false // 调整赛制模态框
    }
  },
  components: {
    AddOrUpdate,
    QueryView,
    ElEnrollInfo,
    ElEnrollInfoOld,
    ElEnrollInfoDouble,
    ElEnrollInfoDoubleOld,
    UpdateReferee,
    GradeInfo,
    GradeInfoOld,
    GradeInfoDouble,
    GradeInfoDoubleOld,
    AdjustGameSys,
    siteDeploy,
    matchIframe
  },
  mounted () {
    this.dataForm.matchId = this.$route.query.matchId
    this.getDataList()
    //this.restaurants = this.loadAll();
    this.initCity()
    console.log(
      new Date('2019-11-11'.replace(/-/, '/')).getTime() > new Date().getTime()
    )
    console.log(new Date().getTime())
  },
  activated () {
    const matchId = this.$route.query.matchId
    if (matchId && matchId !== this.dataForm.matchId) {
      this.dataForm.matchId = matchId
      this.getDataList()
    }
  },
  methods: {
    //推荐或取消推荐
    recommend (id, type) {
      let tips = type == 0 ? '确定取消推荐？' : '确定推荐？'
      let param = {
        id: id,
        recommend: type == 0 ? 0 : 1
      }
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/ctCompetition/updateRecommend'),
          method: 'post',
          data: param
        }).then(e => {
          if (e.code === 0) {
            this.$message.success('操作成功！')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message.info('已取消！')
      })
    },
    // 批量导出参赛名单
    downloadContestants () {
      if (this.selChangeData == null || this.selChangeData.length === 0) {
        this.$message.info('没有要导出的数据!')
        return
      }
      this.$http({
        url: this.$http.adornUrl(`/elEnrollOrder/getCompExportList`),
        method: 'post',
        data: this.selChangeData
      }).then((data) => {
        let arr = data.list
        if (arr.length === 0) {
          return this.$message.info('没有参赛人员输出!')
        }
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].matchType == '-1') {
              arr[i].matchType = ' 青少年比赛'
            } else if (arr[i].matchType == 1) {
              arr[i].matchType = ' 分级公开赛'
            } else if (arr[i].matchType == 2) {
              arr[i].matchType = ' 俱乐部比赛'
            }
            if (arr[i].gender == 0) {
              arr[i].gender = ' 男'
            } else if (arr[i].gender == 1) {
              arr[i].gender = ' 女'
            } else {
              let item = arr[i].gender.split('/')
              let one = item[0] == 0 ? '男' : item[0] == 1 ? '女' : ''
              let two = item[1] == 0 ? '男' : item[1] == 1 ? '女' : ''
              arr[i].gender = one + '/' + two
            }
            if (arr[i].type == 1) {
              arr[i].type = ' 注册会员'
            } else if (arr[i].type == 2) {
              arr[i].type = ' 初级会员'
            } else if (arr[i].type == 3) {
              arr[i].type = ' 荣誉会员'
            } else {
              let item = arr[i].type.split('/')
              let one = item[0] == 1 ? '注册会员' : item[0] == 2 ? '初级会员' : item[0] == 3 ? '荣誉会员' : ''
              let two = item[1] == 1 ? '注册会员' : item[1] == 2 ? '初级会员' : item[1] == 3 ? '荣誉会员' : ''
              arr[i].type = one + '/' + two
            }
        }
        console.log(arr)
        this.$export
        .excel({
          columns: this.table.columns,
          data: arr,
          title: '青少年比赛参赛名单'
        })
        .then(() => {
          this.$message.success('导出表格成功')
        })
      })
    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    //参赛人员管理
    enrollClick (id, projectType, newCompetition) {
      if (projectType == 1) {
        //- 兼容旧数据newCompetition==1是新数据，反之是老数据
        if (newCompetition == 1) {
          this.elEnrollInfoVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfo.init(id)
          })
        } else {
          this.elEnrollInfoOldVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoOld.init(id)
          })
        }
      } else {
        if (newCompetition == 1) {
          this.elEnrollInfoDoubleVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoDouble.init(id)
          })
        } else {
          this.elEnrollInfoDoubleOldVisible = true
          this.$nextTick(() => {
            this.$refs.elEnrollInfoDoubleOld.init(id)
          })
        }
      }
    },
    //1:审核发布 2:设置参数人数
    releaseClick (type, rows) {
      if (
        type == 1 ||
        type == 2 ||
        type == 3 ||
        type == 4 ||
        type == 6 ||
        type == 7 ||
        type === 8 // 调整赛制功能
      ) {
        //赛事状态: 1未审核，2已发布，3已取消，4已结束，5已拒绝
        //未发布的赛事可以审核发布、裁判设置、复制并新建
        if (rows.matchStatus === 1 && type != 1 && type != 3 && type != 5) {
          this.$message.error('比赛尚未发布!')
          return
        }
        //若比赛处在未审核、已拒绝状态（即未发布），此处提示为比赛尚未发布，不能通过此操作取消比赛。
        //已拒绝的赛事可以审核发布、裁判设置、复制并新建
        if (rows.matchStatus === 5 && type != 1 && type != 3 && type != 5) {
          this.$message.error('比赛尚未发布!')
          return
        }

        //已发布的赛事不能审核发布
        if (rows.matchStatus === 2 && type == 1) {
          this.$message.error('比赛已发布!')
          return
        }
        //已取消的比赛可以复制并新建
        if (rows.matchStatus === 3 && type != 5) {
          this.$message.error('比赛已取消!')
          return
        }
        //已结束的比赛可以录入成绩
        if (rows.matchStatus === 4 && type != 2 && type != 4) {
          this.$message.error('比赛已结束!')
          return
        }
      }
      //审核发布
      if (type == 1) {
        this.queryHandle(rows.id, 'release')
        return
      }
      //设置参赛人员
      if (type == 2) {
        this.enrollClick(rows.id, rows.projectType, rows.newCompetition)
      }
      //安排裁判
      if (type == 3) {
        this.updateRefereeVisible = true
        this.$nextTick(() => {
          this.$refs.updateReferee.init(rows)
        })
      }
      //成绩管理
      if (type == 4) {
        //报名结束、已开赛、已结束状态的比赛才可以进行成绩录入，否则名单显示不完整。
        if (rows.matchStatus === 2 || rows.matchStatus === 4) {
          let date1 = new Date()
          let date3 = new Date(rows.matchSignEndTime)
          if (date3.getTime() > date1.getTime()) {
            this.$message.error('报名尚未结束!')
            return
          }
          if (rows.projectType == 1) {
            //单打
            //- 兼容旧数据newCompetition==1是新数据，反之是老数据
            if (rows.newCompetition == 1) {
              this.gradeInfoVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfo.init(rows, -1)
              })
            } else {
              this.gradeInfoOldVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfoOld.init(rows, -1)
              })
            }
          } else {
            //双打
            if (rows.newCompetition == 1) {
              this.gradeInfoDoubleVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfoDouble.init(rows, -1)
              })
            } else {
              this.gradeInfoDoubleOldVisible = true
              this.$nextTick(() => {
                this.$refs.gradeInfoDoubleOld.init(rows, -1)
              })
            }
          }
        }
        return
      }
      //战表管理
      if (type == 10) {
        this.$refs.matchIframe.init(rows.thirdMatchId)
      }
      //复制新建
      if (type == 5) {
        this.openFullScreen()
        console.log(rows.id)
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/copyAdd/` + rows.id),
          method: 'post'
        }).then((data) => {
          // if (data && data.code === 0) {
          //   this.getDataList();
          //   this.$message.success("操作成功!");
          // } else {
          //   this.$message.error("添加失败!");
          // }
          this.loading.close()
          this.addOrUpdateHandle(data.id, 2)
        })
      }
      //取消比赛
      if (type == 6) {
        this.$http({
          url: this.$http.adornUrl(`/elEnrollOrder/getByCtId`),
          method: 'post',
          params: this.$http.adornParams({
            ctId: rows.id
          })
        }).then((data) => {
          if (data && data.code === 0) {
            var flag = true
            for (let i of data.list) {
              if (
                i.payStatus == 2 ||
                i.payStatus == 5 ||
                i.payStatus == 6 ||
                i.payStatus == 10
              ) {
                this.$message.error('请先完成退费操作!')
                flag = false
                return
              }
            }
            let info = '是否取消比赛？'
            if (data.prePay) {
              info = '是否取消比赛，并退回加盟费至原账户？'
            }
            if (flag) {
              this.$confirm(info, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  this.$http({
                    url: this.$http.adornUrl(
                      `/ctCompetition/cancelCompetition`
                    ),
                    method: 'post',
                    data: rows
                  }).then((data) => {
                    console.log('data:', data)
                    if (data && data.code === 0) {
                      if (data.state) {
                        this.getDataList()
                        this.$message.success('比赛已取消')
                      } else {
                        this.$message.error(data.info)
                      }
                    }
                  })
                })
                .catch(() => {
                  this.$message.info('已取消')
                })
            }
          }
        })
      }
      if (type == 7) {
        console.log('结束比赛操作')
        //结束比赛
        let date1 = new Date()
        let date2 = new Date(rows.matchStartTime)
        if (date2.getTime() > date1.getTime()) {
          this.$message.error('比赛尚未开始!')
          return
        }
        //若比赛处在已开赛状态，且未完成成绩录入（即成绩录入表中存在空值），则提示尚未录入成绩，不能通过此操作结束比赛。
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/getByCtId`),
          method: 'post',
          params: this.$http.adornParams({
            ctId: rows.id
          })
        }).then((data) => {
          if (data.elEnrollNum == data.ctScoreNum || (data.elEnrollNum * 2) == data.ctScoreNum) {
            this.$confirm('是否结束比赛？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(async () => {
                this.$http({
                  url: this.$http.adornUrl(`/ctCompetition/endCompetition`),
                  method: 'post',
                  data: rows
                }).then((data) => {
                  if (data && data.code === 0) {
                    this.getDataList()
                    this.$message.success('操作成功')
                  }
                })
              })
              .catch(() => {
                this.$message.info('操作取消')
              })
          } else {
            this.$message.error('尚未录入成绩，不能通过此操作结束比赛')
          }
        })
      }
      // 调整赛制
      if (type === 8) {
        this.adjustGameSysVisible = true
        this.$nextTick(() => {
          this.$refs.adjustGame.init(rows)
        })
      }
      // 场地管理
      if (type === 9) {
        this.siteDeployVisible = true
        this.$nextTick(() => {
          this.$refs.siteDeploy.init(rows)
        })
      }
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //查看和审核发布
    queryHandle (id, type) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, type)
      })
    },
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    getDataList () {
      this.dataListLoading = true
      let ctStrTime = null
      let ctEndTime = null
      if (this.dataForm.matchStartTime !== null) {
        if (this.dataForm.matchStartTime.length > 0) {
          ctStrTime = this.dataForm.matchStartTime[0]
          ctEndTime = this.dataForm.matchStartTime[1]
        }
      }

      this.$http({
        url: this.$http.adornUrl('/ctCompetition/list'),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          matchType: -1,
          matchId: this.dataForm.matchId,
          matchName: this.dataForm.matchName,
          userGroupId: this.dataForm.userGroupId || null,
          ctType: this.dataForm.ctType || null,
          applySize: this.dataForm.applySize || null,
          matchStatus: this.dataForm.matchStatus || null,
          projectType: this.dataForm.projectType || null,
          level: this.dataForm.level || null,
          ctStrTime: ctStrTime,
          ctEndTime: ctEndTime
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.page.rows
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // querySearchDrewOrder(queryString, cb) {
    //   let restaurants = this.restaurants;
    //   let results = queryString
    //     ? restaurants.filter(this.createFilter(queryString))
    //     : restaurants;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return restaurant => {
    //     return (
    //       restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
    //       0
    //     );
    //   };
    // },
    // loadAll() {
    //   return [
    //     { value: "2签位" },
    //     { value: "4签位" },
    //     { value: "8签位" },
    //     { value: "16签位" },
    //     { value: "64签位" },
    //     { value: "128签位" }
    //   ];
    // },
    //比赛项目改变事件
    changeItem (value) {
      this.dataForm.level = ''
      if (value.length > 0) {
        this.levelDisabled = false
        this.placeholderLevel = '请选择'
        if (value == '1') {
          this.levelOptions = this.levelOptionsOne
        }
        if (value == '2') {
          this.levelOptions = this.levelOptionsTwo
        }
      } else {
        this.levelDisabled = true
        this.placeholderLevel = '必须先选择比赛项目'
        this.levelOptions = []
      }
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    //勾选列表事件
    selectionChangeHandle (val) {
      let choseVal = []
      // val.
      val.forEach(item => {
        let arr = {
          ctId: item.id,
          clubName: item.matchName
        }
        choseVal.push(arr)
      })
      this.selChangeData = choseVal
      // let choseVal = val
      // for (let i = 0; i < choseVal.length; i++) {
      //   if (choseVal[i].matchStatus === 1) {
      //     choseVal[i].matchStatusT = '未审核'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date(choseVal[i].matchSignStartTime).getTime() >
      //     new Date().getTime()
      //   ) {
      //     choseVal[i].matchStatusT = '已发布'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date(choseVal[i].matchSignStartTime).getTime() <=
      //     new Date().getTime() &&
      //     new Date().getTime() <=
      //     new Date(choseVal[i].matchSignEndTime).getTime() &&
      //     choseVal[i].joinCount < choseVal[i].applySize
      //   ) {
      //     choseVal[i].matchStatusT = '报名中'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date(choseVal[i].matchSignStartTime).getTime() <=
      //     new Date().getTime() &&
      //     new Date().getTime() <=
      //     new Date(choseVal[i].matchSignEndTime).getTime() &&
      //     choseVal[i].joinCount >= choseVal[i].applySize
      //   ) {
      //     choseVal[i].matchStatusT = '已报满'
      //   } else if (
      //     choseVal[i].matchStatusT === 2 &&
      //     new Date().getTime() >
      //     new Date(choseVal[i].matchSignEndTime).getTime() &&
      //     new Date().getTime() < new Date(choseVal[i].matchStartTime).getTime()
      //   ) {
      //     choseVal[i].matchStatusT = '报名结束'
      //   } else if (
      //     choseVal[i].matchStatus === 2 &&
      //     new Date().getTime() > new Date(choseVal[i].matchStartTime).getTime()
      //   ) {
      //     choseVal[i].matchStatusT = '已开赛'
      //   } else if (choseVal[i].matchStatus === 3) {
      //     choseVal[i].matchStatusT = '已取消'
      //   } else if (choseVal[i].matchStatus === 4) {
      //     choseVal[i].matchStatusT = '已结束'
      //   } else if (choseVal[i].matchStatus === 5) {
      //     choseVal[i].matchStatusT = '已拒绝'
      //   }
      //   if (choseVal[i].ctType === 1) {
      //     choseVal[i].ctTypeT = '常规赛'
      //   } else if (choseVal[i].ctType === 2) {
      //     choseVal[i].ctTypeT = '月度赛'
      //   } else if (choseVal[i].ctType === 3) {
      //     choseVal[i].ctTypeT = '季度赛'
      //   } else if (choseVal[i].ctType === 4) {
      //     choseVal[i].ctTypeT = '年度总决赛'
      //   }
      //   choseVal[i].Signature =
      //     choseVal[i].joinCount + '/' + choseVal[i].applySize
      // }
      // this.selChangeData = choseVal
      // console.log(val)
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}
</style>
